<div class="flex flex-col-reverse gap-8 md:flex-row md:justify-between">
  <ic-password-form class="inline-block" [completed]="completed" (save)="onChangePassword($event)" />

  <div class="inline-block">
    <ic-password-policy-box />
  </div>
</div>
